module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-inner-1000.c637d37a.svg";